import React, { PropsWithChildren } from 'react';
import { Card } from '@material-ui/core';
import styles from './SGSWidgetCard.module.scss';
import classnames from 'classnames';
import SGSCardFooter from './SGSCardFooter';
import SGSCardHeader from './SGSCardHeader';
import SGSCardContent from './SGSCardContent';

type Props = {
    color?: 'primary' | 'secondary' | 'midblue' | 'danger' | 'dark';
    // size?: 'sm' | 'md';
    title: React.ReactNode & string;
    footer?: JSX.Element;
    variant?: 'elevation' | 'outlined';
    className?: string;
};

const SGSWidgetCard: React.FC<PropsWithChildren<Props>> = ({
    color = 'primary',
    // size = 'md',
    children,
    title,
    footer,
    variant = 'outlined',
    className,
    ...props
}) => {
    return (
        <Card {...props} classes={{ root: `${styles.root} ${styles['card-' + color]}` }} variant={variant} className={classnames(/*styles['card-' + size],*/ className)}>
            <SGSCardHeader color={color} title={title} />
            <SGSCardContent color={color === 'dark' ? 'dark' : 'white'}>{children}</SGSCardContent>
            {footer && <SGSCardFooter color="default">{footer}</SGSCardFooter>}
        </Card>
    );
};

export default SGSWidgetCard;
